import PropTypes from 'prop-types';
import { breakpoints, Button, Dialog, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { DangerousHtmlContent } from '@eti/components';
import { CONFIRMATION_MODAL_TYPE, CONFIRMATION_MODAL_ACTION_TYPE } from '../../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const textStyles = isHtml => css`
  font-size: 0.875rem;
  margin: 12px 0;
  ${!isHtml && `font-weight: 700`};
`;
const segmentsStyles = css`
  list-style: disc;
  margin: 12px 10px;
  padding-inline-start: 14px;
`;
const segmentStyles = css`
  font-size: 0.75rem;
`;
const iataStyles = css`
  font-weight: 700;
`;
const dividerStyles = css`
  margin: 0 2px;
`;
const buttonStyles = css`
  flex: 1;
`;
const generateKey = (from, to, i) => `${from}-${to}-${i}`;
const SeatMapConfirmation = _ref => {
  let {
    onSelection,
    segments,
    type = CONFIRMATION_MODAL_TYPE.SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS
  } = _ref;
  const {
    t
  } = useTranslation();
  const segmentIndex = segments.length > 0 ? segments[0].boundSegmentIndex : null;
  const isSkipSeatingPage = type === CONFIRMATION_MODAL_TYPE.SEAT_MAP_PERSIST_IN_PRODUCT;
  return isSkipSeatingPage ? /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": `seatMap-persist-modal-${type}`,
    isOpen: true,
    onDismiss: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
    title: /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: t('Product.SeatMap.Persist.Modal.Title')
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: textStyles(true),
      children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
        content: t('Product.SeatMap.Persist.Modal.Text')
      })
    }), /*#__PURE__*/_jsxs(Inline, {
      collapseBelow: breakpoints._768,
      spacing: 16,
      children: [/*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-persist-modal-dismiss",
        onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_DISMISS),
        children: t('Product.SeatMap.Persist.Modal.Actions.Accept')
      }), /*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-persist-modal-accept",
        onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
        variant: "primary",
        children: t('Product.SeatMap.Persist.Modal.Actions.Dismiss')
      })]
    })]
  }) : /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": `seatMap-persist-modal-${type}`,
    isOpen: true,
    title: t('Product.SeatMap.AllSeatsSelectedConfirmation.Title'),
    children: [/*#__PURE__*/_jsx("div", {
      className: textStyles(false),
      children: t('Product.SeatMap.AllSeatsSelectedConfirmation.Text')
    }), /*#__PURE__*/_jsx("ul", {
      className: segmentsStyles,
      children: segments.map((_ref2, i) => {
        let {
          from,
          to
        } = _ref2;
        return /*#__PURE__*/_jsxs("li", {
          className: segmentStyles,
          children: [from.city, " ", /*#__PURE__*/_jsx("span", {
            className: iataStyles,
            children: from.iata
          }), /*#__PURE__*/_jsx("span", {
            className: dividerStyles,
            children: "\u2013"
          }), to.city, " ", /*#__PURE__*/_jsx("span", {
            className: iataStyles,
            children: to.iata
          })]
        }, generateKey(from, to, i));
      })
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      collapseBelow: breakpoints._768,
      spacing: 16,
      children: [/*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-allSeatsSelectedConfirmation-dismiss",
        onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_DISMISS),
        children: t('Product.SeatMap.AllSeatsSelectedConfirmation.Summary.DismissText')
      }), /*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-allSeatsSelectedConfirmation-accept",
        onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
        variant: "primary",
        children: t('Product.SeatMap.AllSeatsSelectedConfirmation.AcceptText')
      })]
    })]
  });
};
SeatMapConfirmation.propTypes = {
  onSelection: PropTypes.func,
  segments: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  type: PropTypes.oneOf(Object.values(CONFIRMATION_MODAL_TYPE))
};
export default SeatMapConfirmation;
//# sourceMappingURL=SeatMapConfirmation.js.map